// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3sDAk","title":"styles_title__16hwv"};